import { all, takeLatest, put, call, select } from 'redux-saga/effects';
import { selectSelectedOrganizationId } from '../organizations/selectors';
import { onGetBlobsToOrganizations, onDeleteBlobsToOrganizations, onCreateBlobsToOrganizations } from './api';
import {
  createBlobsToOrganizationsForSelectedOrganization,
  createBlobsToOrganizationsForSelectedOrganizationSucceeded,
  createBlobsToOrganizationsForSelectedOrganizationFailed,
  getBlobsToOrganizationsForSelectedOrganization,
  getBlobsToOrganizationsForSelectedOrganizationSucceeded,
  getBlobsToOrganizationsForSelectedOrganizationFailed,
  deleteBlobsToOrganizations,
  deleteBlobsToOrganizationsSucceeded,
  deleteBlobsToOrganizationsFailed
} from './slice';

export function* createBlobsToOrganizationsForSelectedOrganizationWorker({ payload }) {
  const { files } = payload;

  // create array of objects with blob_id and organization_id for each file
  const selectedOrganizationId = yield select(selectSelectedOrganizationId);
  const blobsToOrganizations = files.map((file) => ({
    blob_id: file.id,
    organization_id: selectedOrganizationId
  }));

  try {
    yield call(onCreateBlobsToOrganizations, blobsToOrganizations);
    yield put(createBlobsToOrganizationsForSelectedOrganizationSucceeded());
    yield put(getBlobsToOrganizationsForSelectedOrganization());
  } catch {
    yield put(createBlobsToOrganizationsForSelectedOrganizationFailed());
  }
}

export function* getBlobsToOrganizationsForSelectedOrganizationWorker() {
  const selectedOrganizationId = yield select(selectSelectedOrganizationId);

  try {
    const response = yield call(onGetBlobsToOrganizations, { organization_id: selectedOrganizationId });
    yield put(getBlobsToOrganizationsForSelectedOrganizationSucceeded(response.data));
  } catch {
    yield put(getBlobsToOrganizationsForSelectedOrganizationFailed());
  }
}

export function* deleteBlobsToOrganizationsWorker({ payload }) {
  const { blobToOrganizationIds } = payload;

  try {
    yield call(onDeleteBlobsToOrganizations, blobToOrganizationIds);
    yield put(deleteBlobsToOrganizationsSucceeded());
    yield put(getBlobsToOrganizationsForSelectedOrganization());
  } catch {
    yield put(deleteBlobsToOrganizationsFailed());
  }
}

export default function* blobsToOrganizationsSaga() {
  yield all([
    takeLatest(
      createBlobsToOrganizationsForSelectedOrganization.type,
      createBlobsToOrganizationsForSelectedOrganizationWorker
    ),
    takeLatest(
      getBlobsToOrganizationsForSelectedOrganization.type,
      getBlobsToOrganizationsForSelectedOrganizationWorker
    ),
    takeLatest(deleteBlobsToOrganizations.type, deleteBlobsToOrganizationsWorker)
  ]);
}
